// @flow
import StatementsPage from './StatementsPage';
import * as statementSections from './statementSections';
import useStatementsTitle from './useStatementsTitle';

export default StatementsPage;
export { statementSections, useStatementsTitle };
